import {OffCanvas} from './Components/OffCanvas';
import {LatestSlider} from './Components/LatestSlider';
import {PackageSlider} from './Components/PackageSlider';
import {ReviewsSlider} from './Components/ReviewsSlider';
import {NewsTeaserSlider} from "./Components/NewsTeaserSlider";
import {SpeakerSeminarTeaserSlider} from "./Components/SpeakerSeminarTeaserSlider";
import {ReadMore} from "./Components/ReadMore";

window.addEventListener('DOMContentLoaded', () => {
    new OffCanvas();
    new LatestSlider();
    new PackageSlider();
    new ReviewsSlider();
    new NewsTeaserSlider();
    new SpeakerSeminarTeaserSlider();
    new ReadMore();
});